export default {
  NAVBAR: "navbar",
};
